import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserTelephoneMutationVariables = Types.Exact<{
  input: Types.UpdateUserInput;
}>;


export type UpdateUserTelephoneMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly telephone?: string | null } | null } };

export type GetUserTelephoneForUpdateModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserTelephoneForUpdateModalQuery = { readonly __typename?: 'Query', readonly myUser?: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly telephone?: string | null } | null } | null };


export const UpdateUserTelephoneDocument = gql`
    mutation UpdateUserTelephone($input: UpdateUserInput!) {
  updateUser(input: $input) {
    person {
      telephone
    }
  }
}
    `;
export type UpdateUserTelephoneMutationFn = Apollo.MutationFunction<UpdateUserTelephoneMutation, UpdateUserTelephoneMutationVariables>;

/**
 * __useUpdateUserTelephoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserTelephoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTelephoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTelephoneMutation, { data, loading, error }] = useUpdateUserTelephoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserTelephoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTelephoneMutation, UpdateUserTelephoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTelephoneMutation, UpdateUserTelephoneMutationVariables>(UpdateUserTelephoneDocument, options);
      }
export type UpdateUserTelephoneMutationHookResult = ReturnType<typeof useUpdateUserTelephoneMutation>;
export type UpdateUserTelephoneMutationResult = Apollo.MutationResult<UpdateUserTelephoneMutation>;
export type UpdateUserTelephoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserTelephoneMutation, UpdateUserTelephoneMutationVariables>;
export const GetUserTelephoneForUpdateModalDocument = gql`
    query GetUserTelephoneForUpdateModal {
  myUser {
    _id
    person {
      telephone
    }
  }
}
    `;

/**
 * __useGetUserTelephoneForUpdateModalQuery__
 *
 * To run a query within a React component, call `useGetUserTelephoneForUpdateModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTelephoneForUpdateModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTelephoneForUpdateModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTelephoneForUpdateModalQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTelephoneForUpdateModalQuery, GetUserTelephoneForUpdateModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTelephoneForUpdateModalQuery, GetUserTelephoneForUpdateModalQueryVariables>(GetUserTelephoneForUpdateModalDocument, options);
      }
export function useGetUserTelephoneForUpdateModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTelephoneForUpdateModalQuery, GetUserTelephoneForUpdateModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTelephoneForUpdateModalQuery, GetUserTelephoneForUpdateModalQueryVariables>(GetUserTelephoneForUpdateModalDocument, options);
        }
export type GetUserTelephoneForUpdateModalQueryHookResult = ReturnType<typeof useGetUserTelephoneForUpdateModalQuery>;
export type GetUserTelephoneForUpdateModalLazyQueryHookResult = ReturnType<typeof useGetUserTelephoneForUpdateModalLazyQuery>;
export type GetUserTelephoneForUpdateModalQueryResult = Apollo.QueryResult<GetUserTelephoneForUpdateModalQuery, GetUserTelephoneForUpdateModalQueryVariables>;